import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { EntityConsumedApisCard } from '@backstage/plugin-api-docs';
import {
  EntityDependsOnComponentsCard,
  EntityDependsOnResourcesCard,
} from '@backstage/plugin-catalog';

import { DependsOnContentsCard } from '../../content/DependsOnContentsCard';
import { DependsOnSeamlessCard } from '../../seamless/DependsOnSeamlessCard';

export const dependenciesContent = (args: {
  canConsumeApis: boolean;
  dependsOnContent: boolean;
  dependsOnSeamless: boolean;
}) => (
  <Grid container spacing={3} alignItems="stretch">
    <Grid item md={12} xl={6}>
      <Box sx={{ height: '100%' }}>
        <EntityDependsOnComponentsCard />
      </Box>
    </Grid>
    <Grid item md={12} xl={6}>
      <Box sx={{ height: '100%' }}>
        <EntityDependsOnResourcesCard />
      </Box>
    </Grid>
    {args.dependsOnContent && (
      <Grid item md={12} xl={6}>
        <Box sx={{ height: '100%' }}>
          <DependsOnContentsCard />
        </Box>
      </Grid>
    )}
    {args.dependsOnSeamless && (
      <Grid item md={12} xl={6}>
        <Box sx={{ height: '100%' }}>
          <DependsOnSeamlessCard />
        </Box>
      </Grid>
    )}
    {args.canConsumeApis && (
      <Grid item md={12} xl={6}>
        <Box sx={{ height: '100%' }}>
          <EntityConsumedApisCard />
        </Box>
      </Grid>
    )}
  </Grid>
);
